import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../redux/hooks";
import { Helmet } from "react-helmet";
import { buildBrandedFaviconDataUrl } from "../../utils/brandedFavicon";
import { pickConfigString } from "../../utils/tenancySeo";
import { resolvePrimaryColour, shouldUseMitoRed } from "../../utils/mitoBrand";

const HeaderConfig: React.FC = () => {
  const { tenancyConfigData } = useAppSelector((state) => ({
    tenancyConfigData: state.affiliate.multiTenancyConfigData,
  }));

  const brandedFallback = useMemo(
    () => buildBrandedFaviconDataUrl(resolvePrimaryColour(tenancyConfigData)),
    [tenancyConfigData],
  );

  const [faviconHref, setFaviconHref] = useState<string>(brandedFallback);

  useEffect(() => {
    if (shouldUseMitoRed(tenancyConfigData)) {
      setFaviconHref(brandedFallback);
      return;
    }
    if (tenancyConfigData?.affiliateFavicon) {
      setFaviconHref(tenancyConfigData.affiliateFavicon);
    } else {
      setFaviconHref(brandedFallback);
    }
  }, [tenancyConfigData, brandedFallback]);

  return (
    <div>
      <Helmet>
        <title>
          {pickConfigString(
            tenancyConfigData,
            "siteSeoTitle",
            "SiteSeoTitle",
            "siteseotitle",
          ) || tenancyConfigData?.affiliateName}
        </title>
        <link rel="icon" href={faviconHref} />
        <link rel="apple-touch-icon" href={faviconHref} />
      </Helmet>
    </div>
  );
};

export default HeaderConfig;
